module.exports = __webpack_public_path__ + "img/delete.ce8744f8.svg";